import { useRef } from 'react';
import { trackSectionViewed } from '../utils/tracking';
import { usePublicIntersectionObserver } from './usePublicIntersectionObserver';
export function useTrackSectionViewed(name, screen) {
  const sectionRef = useRef(null);
  usePublicIntersectionObserver({
    onIntersect: () => {
      trackSectionViewed({
        name,
        screen,
        action: 'scrolled in view'
      });
    },
    targetRef: sectionRef,
    threshold: 0.5
  });
  return sectionRef;
}